import { createAction, ActionsUnion } from "../definitions";
import { TripAnnotationActionTypes } from "./types";
import TripAnnotation from "../../model/TripAnnotation";

export interface ITripAnnotationPayload {
    deviceId: string;
    tripAnnotations: IIdDictionary<TripAnnotation>;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const TripAnnotationActions = {
    clearTripAnnotations: () => createAction(TripAnnotationActionTypes.CLEAR_TRIPANNOTATIONS),
    setTripAnnotations: (payload: ITripAnnotationPayload) => createAction(TripAnnotationActionTypes.SET_TRIPANNOTATIONS, payload)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type TripAnnotationActions = ActionsUnion<typeof TripAnnotationActions>;